import { render, staticRenderFns } from "./BeaconList.vue?vue&type=template&id=1a89eee2&"
import script from "./BeaconList.vue?vue&type=script&lang=ts&"
export * from "./BeaconList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports